import { ignoreAbortError } from '@/utils/abort-util'
import type { NavigateFn } from '@/RootStore'
import { validate as isValidUUID } from 'uuid'
import { task } from 'mobx-task'
import type { ActivationLifecycle } from '@/infra/activation'
import { LifecycleTracker } from '@/infra/lifecycle-tracker'
import { PasswordResetViewModel } from '@/features/iam/auth/PasswordReset/PasswordResetViewModel'
import type { UserStore } from '@/features/iam/users/UserStore'

export class CompleteRegistrationViewModel implements ActivationLifecycle {
  private readonly _lifecycle = new LifecycleTracker()

  /**
   * Password reset view model.
   */
  passwordResetVm: PasswordResetViewModel

  constructor(
    private readonly _passwordRequestId: string | undefined,
    private readonly _userStore: UserStore,
    private readonly _navigate: NavigateFn,
  ) {
    this.passwordResetVm = new PasswordResetViewModel(
      this._userStore,
      this._navigate,
    )
  }

  activate() {
    this._lifecycle.activate()
    void this.fetch().catch(ignoreAbortError())
  }

  deactivate() {
    this._lifecycle.deactivate()
  }

  fetch = task(async () => {
    const passwordRequestId = this._passwordRequestId
    if (!passwordRequestId || !isValidUUID(passwordRequestId)) {
      throw new Error('Invalid password request id')
    }

    const result = await this._userStore.fetchPasswordResetRequest(
      passwordRequestId,
      this._lifecycle.signal,
    )

    this.passwordResetVm.setPasswordResetRequest(result.id, result.email)
  })
}
